<template>
    <article class="flex flex-col items-center gap-4 px-4 text-center">
        <div class="flex h-12 items-center justify-center">
            <slot name="logo" />
        </div>
        <blockquote class="text-xs italic leading-5 text-zinc-900">
            “{{ quote }}”
        </blockquote>
        <footer class="flex flex-col gap-0 text-xs leading-5 text-zinc-900">
            <span>{{ author }}</span>
            <span>- {{ role }}</span>
        </footer>
    </article>
</template>

<script setup lang="ts">
defineProps<{
    quote: string;
    author: string;
    role: string;
}>();
</script>
